import { Injectable } from '@angular/core';
import { L7Response } from '@biz-models/network/l7-response.model';
import { UserPermissionsNetworkModel } from '@biz-models/network/user-permissions-network.model';
import { UserProfileNetworkModel } from '@biz-models/network/user-profile-network.model';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  constructor(private apiService: ApiService) {}

  getUserProfile$() {
    return this.apiService.get$<L7Response<UserProfileNetworkModel>>(
      'sso-ms',
      `user/profile`
    );
  }
}
